import { useEffect, useState } from "react";
import { http } from "@/lib/api";

export const PERSONALITIES = [
  ["calm", "Calm", "Grounded & gentle"],
  ["curious", "Curious", "Always asks 'what if?'"],
  ["funny", "Funny", "Kind, playful humor"],
  ["encouraging", "Encouraging", "Celebrates every step"],
  ["wise", "Wise", "Deep, simple questions"],
];
export const VOICES = [["nova", "Bright"], ["shimmer", "Soft"], ["coral", "Warm"], ["sage", "Calm"], ["fable", "Storyteller"], ["echo", "Deep"], ["alloy", "Even"]];
export const SKINS = ["fair", "light olive", "golden tan", "medium brown", "warm brown", "deep brown"];
export const HAIRS = ["short curly black", "long straight black", "wavy brown", "braided", "short blond", "red ponytail", "locs", "afro puffs", "buzz cut"];
export const STYLES = ["a green hoodie", "a denim jacket", "a cozy knit sweater", "a school polo", "a rainbow t-shirt", "a sports jersey"];

export const portraitSrc = (b) => (b?.avatar_url ? `${process.env.REACT_APP_BACKEND_URL}${b.avatar_url}` : null);

export function useSubjects() {
  const [subjects, setSubjects] = useState([]);
  useEffect(() => { http.get("/subjects").then((r) => setSubjects(r.data)).catch(() => {}); }, []);
  return subjects;
}

let current;
export async function speak(text, voice, rate = 1, lang) {
  current?.pause();
  const r = await http.post("/tts", { text, voice, lang }, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  current = new Audio(url);
  current.playbackRate = rate;
  current.onended = () => URL.revokeObjectURL(url);
  await current.play();
}
let seq = 0;
export const stopSpeaking = () => { seq++; current?.pause(); };

const playOnce = async (text, voice, rate, id, lang) => {
  const r = await http.post("/tts", { text, voice, lang }, { responseType: "blob" });
  if (id !== seq) return;
  const url = URL.createObjectURL(r.data);
  current?.pause();
  current = new Audio(url);
  current.playbackRate = rate;
  await new Promise((res) => { current.onended = current.onpause = () => { URL.revokeObjectURL(url); res(); }; current.play().catch(res); });
};

// Speaks "{...}" parts as separate Spanish clips so each language is pronounced correctly
export async function speakMixed(text, voice, rate = 0.85) {
  const id = ++seq;
  for (const [i, part] of text.split(/[{}]/).entries()) {
    const t = part.replace(/^[\s.,]+|[\s,]+$/g, "");
    if (!t || id !== seq) continue;
    await playOnce(t, voice, i % 2 ? 1 : rate, id, i % 2 ? "es" : undefined);
  }
}
export const plainMixed = (text) => text.replace(/[{}]/g, "");

// English then Spanish as separate clips, so each is pronounced in its own language
export async function speakBoth(en, es, voice, rate = 0.85) {
  const id = ++seq;
  if (en) await playOnce(en, voice, rate, id);
  if (es && id === seq) await playOnce(`En español: ${es.replace(/\s*\/\s*/g, ", ")}.`, voice, 1, id, "es");
}

export const FEELINGS = [
  ["happy", "Happy", "#F2D49B"], ["calm", "Calm", "#C8DCCB"], ["excited", "Excited", "#F6C6A8"], ["tired", "Tired", "#D9D4E7"],
  ["worried", "Worried", "#BFD4E6"], ["sad", "Sad", "#A9C1D9"], ["angry", "Angry", "#F2B3A8"],
];
export const feelingColor = (f) => FEELINGS.find((x) => x[0] === f)?.[2] || "#F1EADB";
